/**
 * POST /api/google_users
 *
 * The request contract, read off `civicdinners_web` at 0314db06 (the merged
 * OOH-49 fix) and exercised against it directly:
 *
 *   credential   TOP LEVEL. The raw Google ID token. `GoogleUserService#credential`
 *                reads `params[:credential]` first and falls back to
 *                `params[:user][:credential]`. This is the ONLY thing that
 *                establishes who the caller is.
 *   site_name    top level -- `Site.find_by_name(params[:site_name])`.
 *   locale       top level -- `ApplicationController#switch_locale`.
 *   user         REQUIRED ON THE SIGNUP PATH, and it must not be empty.
 *                `allowed_attributes` does `params.require(:user)`, and Rails'
 *                `require` raises ParameterMissing on `{}` as well as on a
 *                missing key (actionpack 7.0.10 strong_parameters.rb:471-479).
 *                So `user` carries the two non-identity signup fields the API
 *                still reads, explicitly `null` when we do not have them --
 *                that keeps the object non-empty in every case. Verified: with
 *                `user: {}` a Google SIGNUP returns 400, not an account.
 *
 * Identity fields are deliberately absent. The server does
 * `.except(:email, :uid, :first_name, :last_name, :profile_image)` and replaces
 * every one of them with the verified token claim, so sending them achieves
 * nothing except making the payload look like it still carries identity. Before
 * OOH-49 they WERE the identity, which is how a fabricated uid plus a victim's
 * email address returned that victim's session.
 *
 * Note the server underscores every JSON key on the way in
 * (`config/initializers/json_param_key_transform.rb`), so `signedUpTopicId`
 * would also arrive as `signed_up_topic_id`. Snake case is written out here so
 * the payload matches the Ruby that reads it without a transform in between.
 */
class GoogleUsersApi {
  static create({ credential, locale, signedUpTopicId, signedUpConversationId } = {}) {
    const request = new Request(`${process.env.REACT_APP_API_HOST}/google_users`, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify({
        credential,
        site_name: global.siteName,
        locale,
        user: {
          signed_up_topic_id: signedUpTopicId === undefined ? null : signedUpTopicId,
          signed_up_conversation_id: signedUpConversationId === undefined ? null : signedUpConversationId
        }
      })
    })

    return fetch(request).then((response) => response.json())
  }
}

export default GoogleUsersApi
